
<template>
    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
       {{actionToBePerformed}}
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li><router-link to="/resources-virtual">Back</router-link></li>        
        <li class="active">Add / Update Resource</li>
      </ol>
    </section>

    <section class="content">
        <div class="row">
        <div class="col-xs-12">
          <div class="box">
            <div class="box-body">
              <div class="col-xs-12 col-md-12 col-lg-12">
                <form action="#"  method="post">
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Referral Configuration</h3>
                    </div>
                    <div class="panel-body">
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="name" class="required">Resource Name</label>
                            <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.full_name.required }" v-model="gRowObj.full_name" class="form-control" id="full_name" placeholder="Resource Name"  />
                            <span v-if="submitted && !$v.gRowObj.full_name.required" class="text-red pull-right">Please enter resource name.</span>
                          </div>
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="type" class="required">Customer</label>                  
                              <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.client_id.required }" 
                              id="client_id" v-model="gRowObj.client_id" >
                                  <option value="">--Choose an Customer--</option>
                                  <option v-for="data in clientList" :key="data.id" :value="data.id"
                                  :selected="data.id === gRowObj.client_id">{{data.name}}</option>                      
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.client_id.required" class="text-red pull-right">Please choose an client.</span>
                            </div>
                        </div>
                      </div>
                      <div class="row">
                          <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="name" class="required">Country</label>
                              <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.country_id.required }"  @change="getLanguageList(); getMunicipalityList();" 
                              id="country_id" v-model="gRowObj.country_id">
                                <option value="">--Choose a Country--</option>
                                <option v-for="data in countryList" 
                                :selected="data.country_id === gRowObj.country_id" :key="data.country_id" :value="data.country_id">{{data.country_name}}</option>                    
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.country_id.required" class="text-red pull-right">Please choose an country.</span>
                            </div>
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="type">Service Area</label>                  
                              <treeselect placeholder="Add Keywords" 
                                :multiple="true" 
                                :options="municipalityList" 
                                v-model="gRowObj.selectedMunicipalities"
                                search-nested/>  
                            </div>
                          </div>
                      </div>
                      <div class="row">
                          <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="type" class="required">Type</label>                  
                              <nv-select class="form-control" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.resource_type_id.required }" 
                              id="resource_type_id" v-model="gRowObj.resource_type_id" >
                                  <option value="">--Choose an Type--</option>
                                  <option v-for="data in resourcesTypeList" :key="data.id" :value="data.id"
                                  :selected="data.id === gRowObj.resource_type_id">{{data.type_name}}</option>                      
                              </nv-select>
                              <span v-if="submitted && !$v.gRowObj.resource_type_id.required" class="text-red pull-right">Please choose an type.</span>
                            </div>
                            <div class="form-group col-xs-6 col-sm-6 col-md-6">
                              <label for="drillDownApp">Drill Down App</label>  
                              <treeselect placeholder="--Choose Drill Down App--"
                                :multiple="false" 
                                :options="drillDownApps" 
                                v-model="gRowObj.selectedDrillDownApp"
                                search-nested
                                /> 
                          </div>
                          </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="name">Base URL</label>
                            <input type="text" v-bind:class="{'form-group--error': submitted && !$v.gRowObj.base_uri.url }" 
                            v-model="gRowObj.base_uri" class="form-control" id="base_uri" placeholder="Base URL" />
                            <span v-if="submitted && !$v.gRowObj.base_uri.url" class="text-red pull-right">Please enter valid base url.</span>
                          </div>
                          <div class="form-group col-xs-6 col-sm-6 col-md-6">
                            <label for="referral_source" class="required">Referral Source
                              <span title="Provide source for this referral for better resource management"><i class="fa fa-info-circle margin-10"></i></span>
                            </label>
                              <treeselect placeholder="--Choose or Enter source--"
                                :multiple="false" 
                                :defaultOptions="true"
                                :load-options="loadOptions" 
                                :async="true"
                                id="referral_source"
                                v-model="gRowObj.referral_source"
                                search-nested
                                :cacheOptions="false"
                                @select="addNewSource"
                                v-bind:class="{'form-group--error': submitted && !$v.gRowObj.referral_source.required }"
                                >
                                <div slot="value-label" slot-scope="{ node }">{{ node.raw.customLabel }}</div>
                          </treeselect>
                            <span v-if="submitted && !$v.gRowObj.referral_source.required" class="text-red pull-right">Please choose or enter resource source.</span>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-6 col-sm-6 col-md-6" v-if="isEdit">
                            <div v-if="isGoogleSheetsAvailable">
                              <label for="name">DDE Google Sheets</label>
                              <div class="row" style="margin-top: 5px">
                                <div class="form-group col-xs-6 col-sm-6 col-md-6" v-if="isCustomerSpecificAvailable">
                                    <a :href = "`${googleSheetLinks.customerSpecific}`" target="_blank">Customer Specific Google Sheet</a>
                                </div>
                                <div class="form-group col-xs-6 col-sm-6 col-md-6" v-if="isFacilitySpecificAvailable">
                                    <a :href = "`${googleSheetLinks.facilitySpecific}`" target="_blank">Facility Specific Google Sheet</a>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>                                       
                  </div>
                  </div>
                  <div class="panel panel-default">
                    <div class="panel-heading">
                      <h3 class="panel-title">Products/Services available</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-12 col-sm-12 col-md-6">
                             <div class="row">
                            <label for="name">Services</label>
                            </div>
                              <label class="checkbox-inline padding-botton-15px"><input type="checkbox" @change="selectAllServices('service')" v-model="allSelectedServices" /> Select All</label>
                                <div v-for="service in servicesList" :key="service.id">
                                  <div class="checkbox-inline col-xs-6 col-sm-4 col-md-3 col-lg-6">
                                      <input  type="checkbox" v-model="gRowObj.services" :value="service.id" @click="selectService('service')"/>{{service.legacy_name}}
                                  </div>
                              </div> 
                          </div>
                          <div class="form-group col-xs-12 col-sm-12 col-md-6">
                            <div class="row">
                            <label for="name">Products</label>
                            </div>
                              <label class="checkbox-inline padding-botton-15px"><input type="checkbox" @change="selectAllServices('product')" v-model="allSelectedProducts" /> Select All</label>
                                <div v-for="data in productList" :key="data.id">
                                  <div class="checkbox-inline col-xs-6 col-sm-4 col-md-3 col-lg-6">
                                      <input  type="checkbox" v-model="gRowObj.products" :value="data.id" @click="selectService('product')"/>{{data.legacy_name}}
                                  </div>
                              </div> 
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="panel panel-default">
                      <div class="panel-heading">
                        <h3 class="panel-title">Display text for resource</h3>
                      </div>
                      <div class="panel-body">
                        <div class="row">
                          <div class="col-md-12 col-lg-12 col-xs-12">
                            <div class='col-xs-4 col-sm-4 col-md-4'>
                              <div class="form-group col-xs-12 col-sm-12 col-md-12">
                                <label for="name" class="required">Language</label>
                                <nv-select class="form-control" v-bind:class="{'form-group--error': submittedRes && !$v.resourcesTextObj.language_id.required}" 
                                id="language_id" v-model="resourcesTextObj.language_id">
                                  <option value="">--Choose a Language--</option>
                                  <option v-for="data in languageList" 
                                  :selected="data.language_id === resourcesTextObj.language_id" :key="data.language_id" :value="data.language_id">{{data.language_name}}</option>                    
                                </nv-select>
                                <span v-if="submittedRes && !$v.resourcesTextObj.language_id.required" class="text-red pull-right">Please choose an language.</span>
                              </div>
                              <div class="form-group col-xs-12 col-sm-12 col-md-12">
                                <label>Button Text</label>
                                <nv-select class="form-control" v-model="resourcesTextObj.button_text">
                                  <option value="">--Choose Button Text--</option>
                                  <option v-for="data in resourceButtonTexts" 
                                  :selected="data.value === resourcesTextObj.button_text" :key="data.value" :value="data.value">{{data.label}}</option>                    
                                </nv-select>
                              </div>
                            </div>
                            <div class='col-xs-8 col-sm-8 col-md-8'>
                              <div class="row">
                                <div class="form-group col-xs-9 col-sm-9 col-md-9">
                                  <label for="resource-long-text" class="required">Resource Long Text</label>
                                  <textarea v-bind:class="{'form-group--error': submittedRes && (!$v.resourcesTextObj.resource_display_text.required|| !$v.resourcesTextObj.resource_display_text.maxLength)}"
                                  v-model="resourcesTextObj.resource_display_text" class="form-control" rows="4" id="langageMessage" placeholder="Resource Long Text"></textarea>
                                  <span v-if="submittedRes && !$v.resourcesTextObj.resource_display_text.required" class="text-red pull-right">Please enter a text.</span>
                                  <span v-if="submittedRes && !$v.resourcesTextObj.resource_display_text.maxLength" class="text-red pull-right">Text is exceeding character limit of 1000 characters.</span>
                                </div>
                                <div class="form-group col-xs-3 col-sm-3 col-md-3 padding-top-15px">
                                    <i class="fa fa-plus-circle add-property" v-on:click="addResourcesText()" aria-hidden="true" style="margin-left: 20px;"></i>
                                </div>
                              </div>
                              <div class="row">
                                <div class="form-group col-xs-9 col-sm-9 col-md-9">
                                  <label for="name" class="required">Resource Short Text</label>
                                  <input type="text" v-bind:class="{'form-group--error': submittedRes &&  (!$v.resourcesTextObj.resource_short_text.required || !$v.resourcesTextObj.resource_short_text.maxLength)}"
                                  v-model="resourcesTextObj.resource_short_text" class="form-control" id="shortText" placeholder="Resource Short Text"  />
                                  <span v-if="submittedRes && !$v.resourcesTextObj.resource_short_text.required"  class="text-red pull-right">Please enter resource short text.</span>
                                  <span v-if="submittedRes && !$v.resourcesTextObj.resource_short_text.maxLength" class="text-red pull-right">Text is exceeding character limit of 250 characters.</span>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>

                      <div class="row">
                        <div class="col-md-12 col-lg-12 col-xs-12">
                          <div class="form-group col-xs-12 col-sm-12 col-md-12">
                            <table class="" style="width:100%" v-if="Object.keys(gRowObj.resourcesText).length">
                              <thead class="thead-dark">
                              <tr>
                                <th>Language</th>
                                <th>Button Text</th>
                                <th>Resource Long Text</th>
                                <th>Resource Short Text</th>
                                <th>Edit</th>
                                <th>Delete</th>
                              </tr>
                            </thead>
                              <tr v-for="(item, index) in gRowObj.resourcesText" :key="index">
                                <td style="width: 15%;">{{item.language_name}}</td>
                                <td style="width: 15%;">{{getButtonText(item.button_text)}}</td>
                                <td style="width: 35%;word-break: break-all;">{{item.resource_display_text}}</td>
                                <td style="width: 15%;word-break: break-all;">{{item.resource_short_text}}</td>
                                <td style="width:10%">
                                  <i @click="editResourcesText(item, index)" class="fa fa-pencil" aria-hidden="true"></i>
                                </td>
                                <td style="width:10%">
                                  <i @click="deleteResourcesText(item,index)" class="fa fa-times-circle" aria-hidden="true"></i>
                                </td>
                              </tr>
                          </table>
                          </div>
                        </div>
                       </div>

                      </div>
                  </div>
                  <div class="row">
                    <div class="action-button">
                      <button type="button" class="btn btn-primary" @click="close">Cancel</button>
                      <button type="button" class="btn btn-primary margin-left-20px" @click="addOrUpdateOrDeleteResource(0)">Save as Draft</button>
                      <button type="button" class="btn btn-primary margin-left-20px" @click="addOrUpdateOrDeleteResource(1)">Publish</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

    </section>
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>
    </div>
</template>
<script>
  import _ from 'lodash'
  import { Treeselect, ASYNC_SEARCH } from '@riophae/vue-treeselect'
  import { required, url, maxLength } from 'vuelidate/lib/validators'
  import api from '../../../../utils/api'
  import { resourceButtonTexts } from '../helpers'
  export default {
    name: 'modal',
    components: {
      Treeselect
    },
    validations: {
      gRowObj: {
        country_id: { required },
        client_id: { required },
        resource_type_id: { required },
        // classification_id: { required },
        full_name: { required },
        base_uri: { url },
        referral_source: { required }
      },
      resourcesTextObj: {
        language_id: { required },
        resource_display_text: { required, maxLength: maxLength(1000) },
        resource_short_text: { required, maxLength: maxLength(250) }
      }
    },
    data () {
      return {
        allSelectedServices: false,
        allSelectedProducts: false,
        loading: false,
        isEdit: false,
        countryList: [],
        clientList: [],
        servicesList: [],
        productList: [],
        offeringList: [],
        resourcesTypeList: [],
        classificationList: [],
        validationErrors: [],
        countryLanguageList: [],
        languageList: [],
        municipalityList: [],
        previousMunicipalities: [],
        gRowObj: {
          id: null,
          full_name: '',
          country_id: '',
          client_id: '',
          resource_type_id: '',
          classification_id: '',
          physical_or_virtual: 'virtual',
          base_uri: '',
          services: [],
          products: [],
          resourcesText: [],
          selectedMunicipalities: [],
          municipalities: {add: [], remove: []},
          resource_status: null,
          new_status: null,
          selectedDrillDownApp: null,
          referral_source: null
        },
        resourcesTextObj: {
          language_id: '',
          resource_display_text: '',
          resource_short_text: '',
          button_text: ''
        },
        submitted: false,
        submittedRes: false,
        actionToBePerformed: 'Add Resource',
        resourceButtonTexts: resourceButtonTexts,
        drillDownApps: [],
        referralSource: [],
        isGoogleSheetsAvailable: false,
        isCustomerSpecificAvailable: false,
        isFacilitySpecificAvailable: false,
        googleSheetLinks: {
          customerSpecific: '',
          facilitySpecific: ''
        }
      }
    },
    methods: {
      loadOptions ({ action, searchQuery, callback }) {
        if (!searchQuery) {
          callback(null, this.referralSource)
        }
        if (action === ASYNC_SEARCH) {
          const options = []
          options.push({id: searchQuery, label: `${searchQuery} (click to add new source)`, customLabel: searchQuery})
          this.referralSource.forEach(source => {
            if (source.customLabel.toLowerCase() === searchQuery.toLowerCase()) {
              options.shift()
              options.push(source)
            } else if (source.customLabel.toLowerCase().includes(searchQuery.toLowerCase())) {
              options.push(source)
            }
          })
          callback(null, options)
        }
      },
      addNewSource (event) {
        if (event.label.includes('click to add new source')) {
          this.referralSource.push({id: event.id, label: `${event.customLabel} (Recently Added)`, customLabel: event.customLabel})
        }
      },
      selectAllServices (type) {
        if (type === 'service') {
          if (this.allSelectedServices) {
            this.gRowObj.services = []
            for (const services of this.servicesList) {
              this.gRowObj.services.push(services.id)
            }
          } else {
            this.gRowObj.services = []
          }
        } else if (type === 'product') {
          if (this.allSelectedProducts) {
            this.gRowObj.products = []
            for (const product of this.productList) {
              this.gRowObj.products.push(product.id)
            }
          } else {
            this.gRowObj.products = []
          }
        }
      },
      selectService (type) {
        if (type === 'service') {
          if (this.gRowObj.services.length === this.servicesList.length) {
            this.allSelectedServices = true
          } else {
            this.allSelectedServices = false
          }
        } else if (type === 'product') {
          if (this.gRowObj.products.length === this.productList.length) {
            this.allSelectedProducts = true
          } else {
            this.allSelectedProducts = false
          }
        }
      },
      close () {
        this.submitted = false
        this.$router.replace('resources-virtual')
      },
      async addOrUpdateOrDeleteResource (newStatus) {
        if (Object.keys(this.gRowObj.resourcesText).length === 0) {
          this.$swal({
            title: 'Please Add Mandatory fields and Click on "+" button to add it',
            type: 'error'
          })
        } else if (this.resourcesTextObj.language_id !== '' || this.resourcesTextObj.resource_display_text !== '' || this.resourcesTextObj.resource_short_text !== '') {
          this.$swal({
            title: 'Resource description is mandatory. Please click on "+" button to add it.',
            type: 'error'
          })
        } else {
          this.submitted = true
          this.$v.gRowObj.$touch()
          if (this.$v.gRowObj.$invalid) {
            return
          }
          await this.addOrUpdateResources(newStatus)
          this.submitted = false
        }
      },
      async getCountryList () {
        return new Promise(resolve => {
          api.buildRequest('getCountryList', 'POST').then(({ data }) => {
            this.countryList = data.payload.filter(item => item.country_name !== 'Global')
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getServicesList () {
        return new Promise(resolve => {
          api.buildRequest('getServicesList', 'POST').then(({ data }) => {
            this.offeringList = data.payload
            this.servicesList = data.payload.filter(obj => obj.type === 'Service')
            this.productList = data.payload.filter(obj => obj.type === 'Product')
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getMunicipalityList (countryId, resetMunicipalities = true) {
        if (resetMunicipalities) this.gRowObj.selectedMunicipalities = []
        const param = {
          country_id: countryId || this.gRowObj.country_id
        }
        if (param.country_id) {
          return new Promise(resolve => {
            api.buildRequest('getMunicipalityList', 'POST', param).then(({ data }) => {
              this.municipalityList = data.payload.map(i => { return { id: i.id, label: i.name } })
              resolve()
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        }
      },
      async getLanguageList (countryId) {
        this.resourcesTextObj.language_id = ''
        const param = {
          country_id: countryId || this.gRowObj.country_id
        }
        if (param.country_id) {
          return new Promise(resolve => {
            api.buildRequest('getLanguageListByCountry', 'POST', param).then(({ data }) => {
              this.gRowObj.resourcesText = []
              this.resourcesTextObj.language_id = ''
              this.resourcesTextObj.resource_display_text = ''
              this.resourcesTextObj.resource_short_text = ''
              this.resourcesTextObj.language_name = ''
              this.languageList = data.payload
              resolve()
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                title: 'Failure',
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        }
      },
      async getResourceDetails (id) {
        const param = {
          id: id
        }
        return new Promise(resolve => {
          api.buildRequest('getVirtualResourcesDetails', 'POST', param).then(async ({ data }) => {
            if (data && data.payload && data.payload) {
              const objRes = data.payload
              this.gRowObj.id = objRes.id
              this.gRowObj.full_name = objRes.full_name
              this.gRowObj.country_id = objRes.country_id
              this.gRowObj.client_id = objRes.client_id
              this.gRowObj.resource_type_id = objRes.resource_type_id
              this.gRowObj.physical_or_virtual = objRes.physical_or_virtual
              this.gRowObj.base_uri = objRes.base_uri
              this.gRowObj.id = objRes.id
              this.gRowObj.services = objRes.services
              this.gRowObj.products = objRes.products
              this.gRowObj.selectedMunicipalities = objRes.municipalities
              this.previousMunicipalities = objRes.municipalities
              this.gRowObj.resource_status = objRes.resource_status
              this.gRowObj.selectedDrillDownApp = objRes.drill_down_app_id
              this.gRowObj.referral_source = objRes.referral_source ? objRes.referral_source.toLowerCase() : null

              if (this.$route.query.action === 'copyResource') {
                this.gRowObj.full_name = ''
                this.gRowObj.id = null
                this.gRowObj.resource_status = ''
              }

              if (objRes.googleSheetLinks && objRes.googleSheetLinks.customerSpecific) {
                this.isGoogleSheetsAvailable = true
                this.isCustomerSpecificAvailable = true
                this.googleSheetLinks.customerSpecific = objRes.googleSheetLinks.customerSpecific
              }
              if (objRes.googleSheetLinks && objRes.googleSheetLinks.facilitySpecific) {
                this.isGoogleSheetsAvailable = true
                this.isFacilitySpecificAvailable = true
                this.googleSheetLinks.facilitySpecific = objRes.googleSheetLinks.facilitySpecific
              }
              await this.getLanguageList(this.gRowObj.country_id)
              await this.getMunicipalityList(this.gRowObj.country_id, false)
              this.gRowObj.resourcesText = objRes.resourcesText
              this.selectService()
            }
            this.loading = false
            resolve(true)
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      getReferralResourceType () {
        return new Promise(resolve => {
          this.resourcesTypeList = [
            {
              id: 'ePharmacy',
              type_name: 'ePharmacy'
            },
            {
              id: 'eConsultation',
              type_name: 'eConsultation'
            },
            {
              id: 'eCommerce',
              type_name: 'eCommerce'
            }
          ]
          resolve(true)
          // api.buildRequest('/getReferralResourceType', 'POST')
          // .then(response => {
          //   if (response.status === 200) {
          //     const resourceType = ['ePharmacy', 'eConsultation', 'eCommerce']
          //     const classificationTypes = ['Public', 'Private']
          //     this.referralResourceTypeList = response.data.payload
          //     // -- for resource type
          //     this.resourcesTypeList = response.data.payload.filter(i => resourceType.includes(i.type_name))
          //     // -- for classification
          //     this.classificationList = response.data.payload.filter(i => classificationTypes.includes(i.type_name))
          //   }
          //   resolve(true)
          // }).catch(({ response }) => {
          //   resolve(true)
          //   this.loading = false
          //   this.$swal({
          //     type: 'error',
          //     text: response ? response.data.payload.message : 'An error occurred'
          //   })
          // })
        })
      },
      async getClientList () {
        return new Promise(resolve => {
          api.buildRequest('getClientData', 'POST').then(({ data }) => {
            this.clientList = data.payload
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      formatMunicipalities () {
        const newList = this.gRowObj.selectedMunicipalities
        const oldList = this.previousMunicipalities
        const itemsToAdd = _.difference(newList, oldList)
        const itemsToRemove = _.difference(oldList, newList)
        this.gRowObj.municipalities = {
          add: itemsToAdd,
          remove: itemsToRemove
        }
      },
      async addOrUpdateResources (newStatus) {
        this.loading = true
        this.formatMunicipalities()
        this.gRowObj.new_status = newStatus
        var param = this.gRowObj
        if (this.gRowObj.id) {
          // -- call edit
          return new Promise(resolve => {
            api.buildRequest('updateVirtualResources', 'POST', param).then(({ data }) => {
              this.$swal({
                title: 'Success',
                type: 'success',
                text: data.payload.message ? data.payload.message : 'Resource updated successfully'
              }).then(() => {
                this.$router.push({ name: '/resources-virtual' })
              })
              if (data.payload) {
                this.gRowObj.resource_status = data.payload.new_status
              }
              resolve()
              this.loading = false
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                title: 'Failure',
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        } else {
          // -- call add
          return new Promise(resolve => {
            api.buildRequest('addVirtualResources', 'POST', param).then(({ data }) => {
              if (data.payload) {
                this.isEdit = true
                this.gRowObj.id = data.payload.id
              }
              this.$swal({
                title: 'Success',
                type: 'success',
                text: 'Resources added successfully'
              }).then(() => {
                this.$router.push({ name: '/resources-virtual' })
              })
              resolve()
              this.loading = false
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                title: 'Failure',
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
          })
        }
      },
      getSelectedText (event) {
        if (event === 'country') {
          const filterCountry = this.countryList.filter(obj => obj.country_id === this.gRowObj.country_id)
          if (filterCountry && Object.keys(filterCountry).length) {
            this.gRowObj.country_name = filterCountry[0].country_name
          }
        }
        if (event === 'client') {
          const filterClient = this.clientList.filter(obj => obj.id === this.gRowObj.client_id)
          if (filterClient && Object.keys(filterClient).length) {
            this.gRowObj.client_name = filterClient[0].name
          }
        }
        if (event === 'classification') {
          const filterClassification = this.classificationList.filter(obj => obj.id === this.gRowObj.classification_id)
          if (filterClassification && Object.keys(filterClassification).length) {
            this.gRowObj.classification_name = filterClassification[0].type_name
          }
        }
        if (event === 'resource') {
          const filterResourceType = this.resourcesTypeList.filter(obj => obj.id === this.gRowObj.resource_type_id)
          if (filterResourceType && Object.keys(filterResourceType).length) {
            this.gRowObj.resource_type_name = filterResourceType[0].type_name
          }
        }
      },
      async addResourcesText () {
        this.submittedRes = true
        this.$v.resourcesTextObj.$touch()
        if (this.$v.resourcesTextObj.$invalid) {
          return
        }
        // check is already exist
        const index = this.gRowObj.resourcesText.findIndex(obj => obj.language_id === this.resourcesTextObj.language_id)
        if (index >= 0) {
          this.gRowObj.resourcesText.splice(index, 1)
        }
        const filterLanguage = this.languageList.filter(obj => obj.language_id === this.resourcesTextObj.language_id)
        if (filterLanguage && Object.keys(filterLanguage).length) {
          this.resourcesTextObj.language_name = filterLanguage[0].language_name
        }

        const displayTextObj = {
          language_id: this.resourcesTextObj.language_id,
          resource_display_text: this.resourcesTextObj.resource_display_text,
          resource_short_text: this.resourcesTextObj.resource_short_text,
          language_name: this.resourcesTextObj.language_name,
          button_text: this.resourcesTextObj.button_text
        }
        if (!displayTextObj.button_text) delete displayTextObj.button_text
        this.gRowObj.resourcesText.push(displayTextObj)
        this.resourcesTextObj.language_id = ''
        this.resourcesTextObj.resource_display_text = ''
        this.resourcesTextObj.resource_short_text = ''
        this.resourcesTextObj.button_text = ''
        this.resourcesTextObj.language_name = ''
        this.submittedRes = false
      },
      async editResourcesText (item, index) {
        this.resourcesTextObj.language_id = item.language_id
        this.resourcesTextObj.resource_display_text = item.resource_display_text
        this.resourcesTextObj.resource_short_text = item.resource_short_text
        this.resourcesTextObj.button_text = item.button_text
      },
      async deleteResourcesText (item, index) {
        if (this.gRowObj.resourcesText[index]) {
          this.gRowObj.resourcesText.splice(index, 1)
        }
      },
      getButtonText (val) {
        for (let button of this.resourceButtonTexts) {
          if (button['value'] === val) return button['label']
        }
        return ''
      },
      async getDrillDownApps () {
        return new Promise(resolve => {
          api.buildRequest('getSmsApps', 'POST').then(({ data }) => {
            let resp = data.payload
            resp.forEach((app, index) => {
              this.drillDownApps.push({id: resp[index].id, label: resp[index].appName})
            })
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      },
      async getReferralSource () {
        return new Promise(resolve => {
          api.buildRequest('getReferralSource', 'POST').then(({ data }) => {
            let result = data.payload
            result.forEach(ele => {
              if (ele.referral_source) {
                this.referralSource.push({id: ele.referral_source, label: ele.referral_source, customLabel: ele.referral_source})
              }
            })
            resolve()
          }).catch(({ response }) => {
            resolve(true)
            this.loading = false
            this.$swal({
              title: 'Failure',
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
        })
      }
    },
    async mounted () {
      this.gRowObj = {
        id: null,
        full_name: '',
        country_id: '',
        client_id: '',
        resource_type_id: '',
        classification_id: '',
        physical_or_virtual: 'virtual',
        base_uri: '',
        services: [],
        products: [],
        resourcesText: [],
        selectedMunicipalities: [],
        selectedDrillDownApp: null,
        municipalities: {add: [], remove: []},
        referral_source: null
      }
      this.resourcesTextObj = {
        language_id: '',
        resource_display_text: '',
        resource_short_text: '',
        button_text: ''
      }
      this.loading = true
      await Promise.all([ this.getCountryList(), this.getLanguageList(this.gRowObj.country_id), this.getMunicipalityList(this.gRowObj.country_id), this.getServicesList(), this.getReferralResourceType(), this.getClientList(), this.getDrillDownApps(), this.getReferralSource() ])
      this.actionToBePerformed = 'Add Resource'
      if (this.$route && this.$route.query && this.$route.query.resourceId) {
        if (this.$route.query.action !== 'copyResource') this.actionToBePerformed = 'Update Resource'
        this.isEdit = true
        await this.getResourceDetails(this.$route.query.resourceId)
      }
      this.loading = false
    }
  }
</script>
<style>
.margin-left-20px {
  margin-left: 20px;
}
.form-group .padding-15px {
  padding: 0 15px;
}
.padding-botton-15px {
  padding-bottom: 15px;
}
.padding-top-15px {
  padding-top: 15px;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.body.modal-mask {
  position:fixed;
  height: 100vh;
  overflow-y: hidden;
}
.modal-header h3 {
  width: 100%;
  margin-top: 0;
  color: black;
}
.modal-body {
  overflow: auto;
  margin: 20px 0;
}
.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.disable {
  color: #b3b1b1;
}
.v-autocomplete {
  position:relative;
}
.v-autocomplete-input {
  padding:10px 15px;
  height:34px;
}
.v-autocomplete-list {
  width:calc(100% - 30px);
  border:1px solid #d2d6de;
  position:absolute;
  top:58px;
  z-index:111;
  list-style: none;
  padding: 0%;
  max-height: 110%;
  overflow: overlay;
}
.v-autocomplete-list-item {
  width:100%;
  border-bottom:1px solid #d2d6de;
  padding:6px 12px;
  font-size:14px;
  background-color:white;
  cursor:pointer;
}
.v-autocomplete-list-item:last-child {
  width:100%;
  border-bottom:none;
}
.v-autocomplete-list-item:hover {
  background-color: #d2d6de;
}
.msg-table thead, .msg-table tbody{
  display: inline-block;
}
.msg-table thead{
  width: calc(100% - 17px);
}
.msg-table tbody{
  max-height: calc(100vh - 300px);
  overflow: auto;
}
.msg-table th, .msg-table td {
  display: block;
  float: left;
}
.msg-table th:first-child, .msg-table td:first-child{
  width: calc(20% - 53px);
}
.msg-table th:nth-child(2), .msg-table td:nth-child(2), .msg-table th:nth-child(3), .msg-table td:nth-child(3){
  width: 40%;
}
.msg-table th:nth-child(4), .msg-table td:nth-child(4){
  width: 53px;
}
.alert-success{
   background-color:#d4edda !important; 
   border-color:#d4edda !important
}
.alert-danger{
   background-color:#f7d7da !important; 
   border-color:#f7d7da !important
}
.alert-warning{
   background-color:#fff3cd !important; 
   border-color:#fff3cd !important
}
.alert-info{
   background-color:#cce5ff !important; 
   border-color:#cce5ff !important
}

</style>



// WEBPACK FOOTER //
// addOrUpdateResources.vue?5224652e